const stripeConfig = {
  pk: 'pk_live_zYdLXP0DEIOLDwVz8eulc0u300XmoEtz5j',
};
export default stripeConfig;
